module.exports = __webpack_public_path__ + "static/image/font/pc/bmdohyeon-4@3x.ver2_0_2.jpg?43e25d30";